const venmoSelector = store => store.venmo;

export default venmoSelector;
